module.exports = __webpack_public_path__ + "static/media/upload.1db90365.svg";